export const RANKING_TOOLTIPS = {
  NRF: "The law firm is not part of the ranking for this practice area.",
  NRPA: "The Practice Area is not assessed by the legal directory in this country.",
};

export default RANKING_TOOLTIPS;
